import { toast } from "react-toastify"
import { diasHorarioHibrido, tipoCondominio } from "./optionsSelects"
import moment from 'moment'

export const showNotify = (type, msg, opt = false) => {
    // Options que será passada para o toast. Há outras opções para personalizar a notificação
    let options = {
        autoClose: 1000,
        type
    }
    options = Object.assign(options, opt)
    toast(msg, options)
}

export const copyToClipBoard = (value) => {
    navigator.clipboard.writeText(value)
    showNotify("success", "Copiado para a área de transferência!")
}

export const formatValue = (value) =>
    Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL"
    }).format(value)

export const urlWsOne = ""

export const removeAccents = (str) => {
    let accentMap = {
        á: 'a',
        é: 'e',
        í: 'i',
        ó: 'o',
        ú: 'u',
        à: 'a',
        è: 'e',
        ì: 'i',
        ò: 'o',
        ù: 'u',
        ã: 'a',
        ẽ: 'e',
        ĩ: 'i',
        õ: 'o',
        ũ: 'u',
        â: 'a',
        ê: 'e',
        î: 'i',
        ô: 'o',
        û: 'u',
        ä: 'a',
        ë: 'e',
        ï: 'i',
        ö: 'o',
        ü: 'u',
        Á: 'A',
        É: 'E',
        Í: 'I',
        Ó: 'O',
        Ú: 'U',
        À: 'A',
        È: 'E',
        Ì: 'I',
        Ò: 'O',
        Ù: 'U',
        Ã: 'A',
        Ẽ: 'E',
        Ĩ: 'I',
        Õ: 'O',
        Ũ: 'U',
        Â: 'A',
        Ê: 'E',
        Î: 'I',
        Ô: 'O',
        Û: 'U',
        Ä: 'A',
        Ë: 'E',
        Ï: 'I',
        Ö: 'O',
        Ü: 'U',
        ç: 'c',
        Ç: 'c'
    }
    return str.replace(/[\W\s]/g, (a) => {
        return accentMap[a] || a
    })
}

export const filtroTextoPesquisa = (arrayToFilter, filterText, propertiesToEvaluate) => {
    if (!filterText) {
        return arrayToFilter
    }
    return arrayToFilter && arrayToFilter.filter((fechamento) => {
        const filterTextWithoutAccents = removeAccents(filterText.toLowerCase())
        return propertiesToEvaluate.some(property => {
            if (fechamento[property] && removeAccents(fechamento[property].toString().toLowerCase()).includes(filterTextWithoutAccents)) {
                return fechamento
            }
        })
    })
}

export const pageSize = () => {
    let pageSize = document.body.clientHeight - 230
    let rowsMath = Math.round(pageSize / 27, 0)
    return rowsMath
}

export const getMapLink = (endereco) => {
    const mapUrl = `https://www.google.com/maps/place/${endereco}`
    return mapUrl
}

export const getTipoCondominio = (valueTipo) => {
    const result = tipoCondominio.filter(tipo => tipo.value == valueTipo)[0]
    return result
}

export const sleep = (time) => {
    return new Promise(resolve => setTimeout(resolve, time))
}

export const empty = (value) => {
    if (!value || value === undefined || value === "" || value === " " || value === null || value === "null") {
        return true
    } else {
        return false
    }
}

export const objIsEmpty = (obj) => {
    return Object.keys(obj).length == 0
}

export const defineTipoLink = (tipoLink, linkInterno, linkExterno) => {
    if (tipoLink === 'interno' && linkInterno) {
        return linkInterno
    }

    if (linkExterno) {
        return linkExterno
    }

    return null
}

export const formatLinkWithDate = (link) => {
    return `${link}&d=${new Date().getTime()}`
}

export const getDiaHibrido = (dia) => {
    const diaObj = diasHorarioHibrido.filter(d => d.value == dia)[0]

    return diaObj.descricao
}

let audiosTocando = {}

export const tocarAudio = (nome, evento = -1, callback = false) => {
    const caminho = require(`../Assets/Audios/sonsEventos/${nome}`)
    const audio = new Audio(caminho)
    audio.onended = function onAudioEnded() {
        if (typeof callback === 'function') {
            callback()
        }
        limpaAudio(evento)
    }
    audiosTocando[evento] = audio
    audiosTocando[evento].play()
}

export const pararAudio = (evento = -1, callback = false) => {
    limpaAudio(evento)
}

export const limpaAudio = (evento, tempo = 1000) => {
    if (audiosTocando[evento]) {
        setTimeout(() => {
            audiosTocando[evento].pause()
            audiosTocando[evento] = null
            delete audiosTocando[evento]
        }, tempo)
    }
}

export const formatDateTime = (dateTime) => {
    if (dateTime) {
        return moment(dateTime).format('DD/MM/YY HH:mm')
    }
}

export const formatDate = (date, format = 'DD/MM/YYYY') => {
    if (date) {
        if (typeof date === 'string' && (date.includes('T') || date.includes('Z'))) {
            return moment.utc(date).format(format)
        }
        return moment(date).format(format)
    } else {
        return ''
    }
}

export const data2Sql = (dataSql) => {
    let data = dataSql

    if (dataSql && dataSql.length >= 10 && dataSql.indexOf('/') !== -1) {
        let datatmp = dataSql.split("/")
        if (datatmp && datatmp.length == 3) {
            data = [datatmp[2], datatmp[1], datatmp[0]].join("-")
        }
    }

    return data
}

export const separateDateTime = (dateTime, separator) => {
    if (!dateTime) {
        return [null, null]
    }

    return dateTime.split(separator)
}

global.janelaAtiva = true

window.addEventListener('focus', focusOn)
window.addEventListener('blur', focusOff)

function focusOn() {
    global.janelaAtiva = true
}

function focusOff() {
    global.janelaAtiva = false
}

export const padl = (texto, tam, pad) => {
    let ret = texto
    if (!(texto === undefined || texto == null)) {
        ret = ret.trim()
        if (texto.length < tam) {
            ret = Array(tam - texto.length + 1).join(pad) + texto
        }
    }
    return ret
}

export const TIPOS_LICENCA_COND = {
    REMOTA: 1,
    AG: 2,
    AUTONOMA: 3,
    AGPLUS: 4
}

export const dataComFusoCondominio = (data, fuso_condominio) => {
    const fusoLocal = -new Date().getTimezoneOffset() / 60
    if (fuso_condominio != null && fuso_condominio != undefined && fuso_condominio != '' && fuso_condominio != fusoLocal) {
        const fusoDiferenca = fuso_condominio - fusoLocal
        const dataUtc = moment(data).utcOffset(fusoDiferenca * 60, true).utc().format('YYYY-MM-DD HH:mm:ss')
        return dataUtc
    }
    return data
}
